import { useTranslation } from 'react-i18next';

import { applyLocale, SUPPORTED_LOCALES, type SupportedLocale } from '../../i18n';
import styles from './AdminLanguageSwitcher.module.css';

const LOCALE_LABELS: Record<SupportedLocale, string> = {
  ru: 'RU',
  en: 'EN',
};

// PARA-106 §7 (UI-архитектура) — переключатель RU/EN в Topbar, без привязки
// к серверной локали пользователя (у администратора её нет).
// PARA-120 — сегмент-пилюля дизайн-системы (образец: frontend LanguageSwitcher),
// role="radiogroup"/"radio" для доступности.
export function AdminLanguageSwitcher(): JSX.Element {
  const { i18n } = useTranslation();
  const current = i18n.language as SupportedLocale;
  const selected = SUPPORTED_LOCALES.includes(current) ? current : 'en';

  return (
    <div className={styles.track} role="radiogroup" aria-label="language">
      {SUPPORTED_LOCALES.map((locale) => {
        const active = locale === selected;
        return (
          <button
            key={locale}
            type="button"
            role="radio"
            aria-checked={active}
            className={[styles.segment, active ? styles.active : ''].filter(Boolean).join(' ')}
            onClick={() => applyLocale(locale)}
          >
            {LOCALE_LABELS[locale]}
          </button>
        );
      })}
    </div>
  );
}
